/* eslint react-hooks/exhaustive-deps: "warn" */

import { useRef } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import styles from './ProcessSteps.module.scss';

import type { ProcessStepsProps } from './ProcessSteps.types';

export const ProcessSteps = ({ steps, className }: ProcessStepsProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const go = useIntersection(ref, { threshold: 0.35 });

  return (
    <div ref={ref} className={cn(styles.line, go && styles.go, className)}>
      <div className={styles.track} aria-hidden="true">
        <i />
      </div>

      <div className={styles.grid}>
        {steps.map((step, index) => (
          <div key={step.title} className={styles.step}>
            <span className={styles.dot} aria-hidden="true">
              {index + 1}
            </span>

            <h3 className={styles.title}>{step.title}</h3>
            <p className={styles.description}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
